<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="分类:">
            <el-select v-model="obj.selectedBlockValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectBlockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业:">
            <el-select v-model="obj.selectedIndustryValue" @change="handleSelectChange" style="width:180px">
              <el-option v-for="item in obj.selectIndustryList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指数:">
            <el-select v-model="obj.selectedIndexValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectIndexList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区:">
            <el-select v-model="obj.selectedDistrictValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectDistrictList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指标:">
            <el-select v-model="obj.indicators" placeholder="请选择" @change="handleSelectChange" style="width:170px">
              <el-option-group v-for="group in obj.indicatorsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="形态:">
            <el-select v-model="obj.patterns" placeholder="请选择" @change="handleSelectChange" style="width:120px">
              <el-option-group v-for="group in obj.patternsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <el-tag type="warning" size="small" v-if="obj.date !== ''">数据截至到 {{ obj.date }}</el-tag>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="100px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="最新" prop="close" width="80px" align="right" />
        <el-table-column label="涨跌" prop="chg" width="80px" align="right" sortable />
        <el-table-column label="涨跌幅" prop="chgPct" align="right" width="100px" :sort-method="customPctSort" sortable />
        <el-table-column label="开盘" prop="open" width="80px" align="right" />
        <el-table-column label="最低" prop="low" width="80px" align="right" />
        <el-table-column label="最高" prop="high" width="80px" align="right" />
        <el-table-column label="成交量" prop="vol" width="90px" align="right" :sort-method="customVolSort" sortable />
        <el-table-column label="成交额" prop="turnover" width="100px" align="right" :sort-method="customTurnoverSort" sortable />
        <el-table-column label="前收" prop="preClose" width="80px" align="right" />
        <el-table-column label="趋势度" prop="trend_ma1" width="100px" align="right" sortable/>
        <el-table-column label="换手率" prop="turnoverRate_ma1" width="100px" align="right" :sort-method="customTurnoverRateSort" sortable/>
        <el-table-column label="振幅" prop="amplitude" width="100px" align="right" :sort-method="customAmplitudeSort" sortable/>
        <el-table-column prop="industry" label="行业" width="120px" align="right" />
        <el-table-column prop="index" label="指数" width="180px" align="right" />
        <el-table-column prop="district" label="地区" width="80px" align="right" />
      </el-table>
      <el-pagination background layout="prev, pager, next" :page-size="obj.limit" :total="obj.total"
        :current-page="obj.page" class="mt-16" @current-change="handlePageChange"></el-pagination>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { bigNumberTransform, formatDecimalPoint } from '../util/base'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      total: 0,
      page: 1,
      limit: 18,
      selectBlockList: [
        {
          value: 'all',
          label: '全部A股'
        },
        {
          value: 'shse',
          label: '上证A股'
        },
        {
          value: 'szse',
          label: '深证A股'
        },
        {
          value: 'bse',
          label: '北证A股'
        },
        {
          value: 'shse_zb',
          label: '上证主板'
        },
        {
          value: 'szse_zb',
          label: '深证主板'
        },
        {
          value: 'shse_kcb',
          label: '科创版'
        },
        {
          value: 'szse_cyb',
          label: '创业版'
        },
      ],
      selectedBlockValue: 'all',
      selectIndexList: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 'hs300',
          label: '沪深300'
        },
        {
          value: 'sz50',
          label: '上证50'
        },
        {
          value: 'zz500',
          label: '中证500'
        },
        {
          value: 'zz1000',
          label: '中证1000'
        },
        {
          value: 'cy300',
          label: '创业300'
        },
        {
          value: 'kc50',
          label: '科创50'
        },
        {
          value: 'bz50',
          label: '北证50'
        },
      ],
      selectedIndexValue: 'all',
      // selectIndustryList: [{ 'value': 'all', 'label': '全部' }, { 'value': '全国性银行', 'label': '全国性银行' }, { 'value': '房地产开发', 'label': '房地产开发' }, { 'value': '软件服务', 'label': '软件服务' }, { 'value': '商业物业经营', 'label': '商业物业经营' }, { 'value': '轨交设备', 'label': '轨交设备' }, { 'value': '电池', 'label': '电池' }, { 'value': '基础建设', 'label': '基础建设' }, { 'value': '玻璃玻纤', 'label': '玻璃玻纤' }, { 'value': '黑色家电', 'label': '黑色家电' }, { 'value': '饰品', 'label': '饰品' }, { 'value': '农产品加工', 'label': '农产品加工' }, { 'value': '光学光电', 'label': '光学光电' }, { 'value': '消费电子', 'label': '消费电子' }, { 'value': '水泥', 'label': '水泥' }, { 'value': '汽车服务', 'label': '汽车服务' }, { 'value': '电力', 'label': '电力' }, { 'value': '医药商业', 'label': '医药商业' }, { 'value': '汽车零部件', 'label': '汽车零部件' }, { 'value': '专业工程', 'label': '专业工程' }, { 'value': '云服务', 'label': '云服务' }, { 'value': '环境治理', 'label': '环境治理' }, { 'value': '通用设备', 'label': '通用设备' }, { 'value': '装修装饰', 'label': '装修装饰' }, { 'value': '房产服务', 'label': '房产服务' }, { 'value': '石油化工', 'label': '石油化工' }, { 'value': '工业金属', 'label': '工业金属' }, { 'value': '其他电子', 'label': '其他电子' }, { 'value': '通信设备', 'label': '通信设备' }, { 'value': 'IT设备', 'label': 'IT设备' }, { 'value': '水务', 'label': '水务' }, { 'value': '航运港口', 'label': '航运港口' }, { 'value': '航空机场', 'label': '航空机场' }, { 'value': '贸易', 'label': '贸易' }, { 'value': '化学制药', 'label': '化学制药' }, { 'value': '广播电视', 'label': '广播电视' }, { 'value': '工程机械', 'label': '工程机械' }, { 'value': '证券', 'label': '证券' }, { 'value': '化纤', 'label': '化纤' }, { 'value': '白色家电', 'label': '白色家电' }, { 'value': '电网设备', 'label': '电网设备' }, { 'value': '生物制品', 'label': '生物制品' }, { 'value': '家电零部件', 'label': '家电零部件' }, { 'value': '燃气', 'label': '燃气' }, { 'value': '农用化工', 'label': '农用化工' }, { 'value': '多元金融', 'label': '多元金融' }, { 'value': '一般零售', 'label': '一般零售' }, { 'value': '中药', 'label': '中药' }, { 'value': '酒店餐饮', 'label': '酒店餐饮' }, { 'value': '公路铁路', 'label': '公路铁路' }, { 'value': '旅游', 'label': '旅游' }, { 'value': '造纸', 'label': '造纸' }, { 'value': '医疗服务', 'label': '医疗服务' }, { 'value': '贵金属', 'label': '贵金属' }, { 'value': '化学原料', 'label': '化学原料' }, { 'value': '地面兵装', 'label': '地面兵装' }, { 'value': '日用化工', 'label': '日用化工' }, { 'value': '教育培训', 'label': '教育培训' }, { 'value': '食品加工', 'label': '食品加工' }, { 'value': '军工电子', 'label': '军工电子' }, { 'value': '商用车', 'label': '商用车' }, { 'value': '煤炭开采', 'label': '煤炭开采' }, { 'value': '化学制品', 'label': '化学制品' }, { 'value': '酿酒', 'label': '酿酒' }, { 'value': '乘用车', 'label': '乘用车' }, { 'value': '自动化设备', 'label': '自动化设备' }, { 'value': '林业', 'label': '林业' }, { 'value': '广告营销', 'label': '广告营销' }, { 'value': '医疗美容', 'label': '医疗美容' }, { 'value': '装饰建材', 'label': '装饰建材' }, { 'value': '保险', 'label': '保险' }, { 'value': '房屋建设', 'label': '房屋建设' }, { 'value': '稀有金属', 'label': '稀有金属' }, { 'value': '综合类', 'label': '综合类' }, { 'value': '金属新材料', 'label': '金属新材料' }, { 'value': '元器件', 'label': '元器件' }, { 'value': '冶钢原料', 'label': '冶钢原料' }, { 'value': '包装印刷', 'label': '包装印刷' }, { 'value': '数字媒体', 'label': '数字媒体' }, { 'value': '航空装备', 'label': '航空装备' }, { 'value': '饲料', 'label': '饲料' }, { 'value': '特钢', 'label': '特钢' }, { 'value': '普钢', 'label': '普钢' }, { 'value': '种植业', 'label': '种植业' }, { 'value': '出版业', 'label': '出版业' }, { 'value': '焦炭加工', 'label': '焦炭加工' }, { 'value': '纺织制造', 'label': '纺织制造' }, { 'value': '养殖业', 'label': '养殖业' }, { 'value': '能源金属', 'label': '能源金属' }, { 'value': '工程咨询服务', 'label': '工程咨询服务' }, { 'value': '渔业', 'label': '渔业' }, { 'value': '影视院线', 'label': '影视院线' }, { 'value': '光伏设备', 'label': '光伏设备' }, { 'value': '专业连锁', 'label': '专业连锁' }, { 'value': '电信服务', 'label': '电信服务' }, { 'value': '饮料乳品', 'label': '饮料乳品' }, { 'value': '专用设备', 'label': '专用设备' }, { 'value': '塑料', 'label': '塑料' }, { 'value': '通信工程', 'label': '通信工程' }, { 'value': '物流', 'label': '物流' }, { 'value': '家居用品', 'label': '家居用品' }, { 'value': '摩托车及其他', 'label': '摩托车及其他' }, { 'value': '电机制造', 'label': '电机制造' }, { 'value': '环保设备', 'label': '环保设备' }, { 'value': '油气开采', 'label': '油气开采' }, { 'value': '橡胶', 'label': '橡胶' }, { 'value': '服装家纺', 'label': '服装家纺' }, { 'value': '休闲食品', 'label': '休闲食品' }, { 'value': '文娱用品', 'label': '文娱用品' }, { 'value': '地方性银行', 'label': '地方性银行' }, { 'value': '风电设备', 'label': '风电设备' }, { 'value': '小家电', 'label': '小家电' }, { 'value': '半导体', 'label': '半导体' }, { 'value': '非金属材料', 'label': '非金属材料' }, { 'value': '电子商务', 'label': '电子商务' }, { 'value': '厨卫电器', 'label': '厨卫电器' }, { 'value': '产业互联网', 'label': '产业互联网' }, { 'value': '动物保健', 'label': '动物保健' }, { 'value': '游戏', 'label': '游戏' }, { 'value': '油服工程', 'label': '油服工程' }, { 'value': '医疗器械', 'label': '医疗器械' }, { 'value': '其他发电设备', 'label': '其他发电设备' }, { 'value': '专业服务', 'label': '专业服务' }, { 'value': '调味品', 'label': '调味品' }, { 'value': '环境监测', 'label': '环境监测' }, { 'value': '航天装备', 'label': '航天装备' }, { 'value': '体育', 'label': '体育' }, { 'value': '航海装备', 'label': '航海装备' }],
      selectIndustryList: [
        { 'value': 'all', 'label': '全部' },
        { 'value': '煤炭开采', 'label': '1002 煤炭开采' },
        { 'value': '焦炭加工', 'label': '1005 焦炭加工' },
        { 'value': '油气开采', 'label': '1007 油气开采' },
        { 'value': '石油化工', 'label': '1011 石油化工' },
        { 'value': '油服工程', 'label': '1008 油服工程' },
        { 'value': '日用化工', 'label': '1016 日用化工' },
        { 'value': '化纤', 'label': '1019 化纤' },
        { 'value': '化学原料', 'label': '1026 化学原料' },
        { 'value': '化学制品', 'label': '1034 化学制品' },
        { 'value': '塑料', 'label': '1044 塑料' },
        { 'value': '橡胶', 'label': '1051 橡胶' },
        { 'value': '农用化工', 'label': '1055 农用化工' },
        { 'value': '非金属材料', 'label': '1104 非金属材料' },
        { 'value': '冶钢原料', 'label': '1062 冶钢原料' },
        { 'value': '普钢', 'label': '1065 普钢' },
        { 'value': '特钢', 'label': '1069 特钢' },
        { 'value': '工业金属', 'label': '1071 工业金属' },
        { 'value': '贵金属', 'label': '1075 贵金属' },
        { 'value': '能源金属', 'label': '1078 能源金属' },
        { 'value': '稀有金属', 'label': '1082 稀有金属' },
        { 'value': '金属新材料', 'label': '1087 金属新材料' },
        { 'value': '水泥', 'label': '1091 水泥' },
        { 'value': '玻璃玻纤', 'label': '1094 玻璃玻纤' },
        { 'value': '装饰建材', 'label': '1097 装饰建材' },
        { 'value': '种植业', 'label': '1106 种植业' },
        { 'value': '养殖业', 'label': '1111 养殖业' },
        { 'value': '林业', 'label': '1115 林业' },
        { 'value': '渔业', 'label': '1116 渔业' },
        { 'value': '饲料', 'label': '1119 饲料' },
        { 'value': '农产品加工', 'label': '1123 农产品加工' },
        { 'value': '动物保健', 'label': '1127 动物保健' },
        { 'value': '酿酒', 'label': '1130 酿酒' },
        { 'value': '饮料乳品', 'label': '1136 饮料乳品' },
        { 'value': '调味品', 'label': '1139 调味品' },
        { 'value': '休闲食品', 'label': '1140 休闲食品' },
        { 'value': '食品加工', 'label': '1144 食品加工' },
        { 'value': '纺织制造', 'label': '1151 纺织制造' },
        { 'value': '服装家纺', 'label': '1157 服装家纺' },
        { 'value': '饰品', 'label': '1162 饰品' },
        { 'value': '造纸', 'label': '1167 造纸' },
        { 'value': '包装印刷', 'label': '1171 包装印刷' },
        { 'value': '家居用品', 'label': '1177 家居用品' },
        { 'value': '文娱用品', 'label': '1180 文娱用品' },
        { 'value': '白色家电', 'label': '1184 白色家电' },
        { 'value': '黑色家电', 'label': '1187 黑色家电' },
        { 'value': '小家电', 'label': '1190 小家电' },
        { 'value': '厨卫电器', 'label': '1194 厨卫电器' },
        { 'value': '家电零部件', 'label': '1198 家电零部件' },
        { 'value': '一般零售', 'label': '1200 一般零售' },
        { 'value': '商业物业经营', 'label': '1204 商业物业经营' },
        { 'value': '专业连锁', 'label': '1205 专业连锁' },
        { 'value': '贸易', 'label': '1206 贸易' },
        { 'value': '电子商务', 'label': '1207 电子商务' },
        { 'value': '乘用车', 'label': '1212 乘用车' },
        { 'value': '商用车', 'label': '1215 商用车' },
        { 'value': '汽车零部件', 'label': '1218 汽车零部件' },
        { 'value': '汽车服务', 'label': '1224 汽车服务' },
        { 'value': '摩托车及其他', 'label': '1227 摩托车及其他' },
        { 'value': '化学制药', 'label': '1231 化学制药' },
        { 'value': '生物制品', 'label': '1234 生物制品' },
        { 'value': '中药', 'label': '1256 中药' },
        { 'value': '医药商业', 'label': '1252 医药商业' },
        { 'value': '医疗器械', 'label': '1241 医疗器械' },
        { 'value': '医疗服务', 'label': '1247 医疗服务' },
        { 'value': '医疗美容', 'label': '1257 医疗美容' },
        { 'value': '电机制造', 'label': '1261 电机制造' },
        { 'value': '电池', 'label': '1262 电池' },
        { 'value': '电网设备', 'label': '1268 电网设备' },
        { 'value': '光伏设备', 'label': '1275 光伏设备' },
        { 'value': '风电设备', 'label': '1282 风电设备' },
        { 'value': '其他发电设备', 'label': '1285 其他发电设备' },
        { 'value': '地面兵装', 'label': '1287 地面兵装' },
        { 'value': '航空装备', 'label': '1288 航空装备' },
        { 'value': '航天装备', 'label': '1289 航天装备' },
        { 'value': '航海装备', 'label': '1290 航海装备' },
        { 'value': '军工电子', 'label': '1291 军工电子' },
        { 'value': '轨交设备', 'label': '1293 轨交设备' },
        { 'value': '通用设备', 'label': '1294 通用设备' },
        { 'value': '专用设备', 'label': '1303 专用设备' },
        { 'value': '工程机械', 'label': '1310 工程机械' },
        { 'value': '自动化设备', 'label': '1313 自动化设备' },
        { 'value': '半导体', 'label': '1319 半导体' },
        { 'value': '消费电子', 'label': '1326 消费电子' },
        { 'value': '光学光电', 'label': '1329 光学光电' },
        { 'value': '元器件', 'label': '1333 元器件' },
        { 'value': '其他电子', 'label': '1336 其他电子' },
        { 'value': '通信设备', 'label': '1338 通信设备' },
        { 'value': '通信工程', 'label': '1347 通信工程' },
        { 'value': '电信服务', 'label': '1344 电信服务' },
        { 'value': 'IT设备', 'label': '1352 IT设备' },
        { 'value': '软件服务', 'label': '1355 软件服务' },
        { 'value': '云服务', 'label': '1359 云服务' },
        { 'value': '产业互联网', 'label': '1364 产业互联网' },
        { 'value': '游戏', 'label': '1369 游戏' },
        { 'value': '广告营销', 'label': '1370 广告营销' },
        { 'value': '影视院线', 'label': '1373 影视院线' },
        { 'value': '数字媒体', 'label': '1376 数字媒体' },
        { 'value': '出版业', 'label': '1380 出版业' },
        { 'value': '广播电视', 'label': '1384 广播电视' },
        { 'value': '全国性银行', 'label': '1386 全国性银行' },
        { 'value': '地方性银行', 'label': '1389 地方性银行' },
        { 'value': '证券', 'label': '1394 证券' },
        { 'value': '保险', 'label': '1395 保险' },
        { 'value': '多元金融', 'label': '1396 多元金融' },
        { 'value': '房屋建设', 'label': '1406 房屋建设' },
        { 'value': '基础建设', 'label': '1407 基础建设' },
        { 'value': '专业工程', 'label': '1410 专业工程' },
        { 'value': '工程咨询服务', 'label': '1415 工程咨询服务' },
        { 'value': '装修装饰', 'label': '1416 装修装饰' },
        { 'value': '房地产开发', 'label': '1418 房地产开发' },
        { 'value': '房产服务', 'label': '1422 房产服务' },
        { 'value': '体育', 'label': '1427 体育' },
        { 'value': '教育培训', 'label': '1428 教育培训' },
        { 'value': '酒店餐饮', 'label': '1429 酒店餐饮' },
        { 'value': '旅游', 'label': '1432 旅游' },
        { 'value': '专业服务', 'label': '1436 专业服务' },
        { 'value': '公路铁路', 'label': '1442 公路铁路' },
        { 'value': '航空机场', 'label': '1446 航空机场' },
        { 'value': '航运港口', 'label': '1449 航运港口' },
        { 'value': '物流', 'label': '1452 物流' },
        { 'value': '电力', 'label': '1459 电力' },
        { 'value': '燃气', 'label': '1467 燃气' },
        { 'value': '水务', 'label': '1468 水务' },
        { 'value': '环保设备', 'label': '1470 环保设备' },
        { 'value': '环境治理', 'label': '1471 环境治理' },
        { 'value': '环境监测', 'label': '1476 环境监测' },
        { 'value': '综合类', 'label': '1478 综合类' }
      ],
      selectedIndustryValue: 'all',
      selectDistrictList: [
        {  
          value: 'all',  
          label: '全部'  
        },  
        {  
          value: '北京',  
          label: '北京'  
        },  
        {  
          value: '上海',  
          label: '上海'  
        },  
        {  
          value: '广东',  
          label: '广东'
        },  
        {  
          value: '深圳',  
          label: '深圳'  
        },  
        {  
          value: '重庆',  
          label: '重庆'  
        },  
        {  
          value: '江苏',  
          label: '江苏'
        },  
        {  
          value: '浙江',  
          label: '浙江'
        },  
        {  
          value: '山东',  
          label: '山东'
        },  
        {  
          value: '天津',  
          label: '天津'  
        },  
        {  
          value: '湖北',  
          label: '湖北'
        },  
        {  
          value: '四川',  
          label: '四川'
        },  
        {  
          value: '陕西',  
          label: '陕西'
        },  
        {  
          value: '福建',  
          label: '福建'
        }, 
        {  
          value: '辽宁',  
          label: '辽宁'
        },  
        {  
          value: '黑龙江',  
          label: '黑龙江'  
        },  
        {  
          value: '新疆',  
          label: '新疆'  
        },  
        {  
          value: '吉林',  
          label: '吉林'  
        },  
        {  
          value: '甘肃',  
          label: '甘肃'  
        },  
        {  
          value: '青海',  
          label: '青海'  
        },  
        {  
          value: '广西',  
          label: '广西'  
        },  
        {  
          value: '河北',  
          label: '河北'  
        },  
        {  
          value: '河南',  
          label: '河南'  
        },  
        {  
          value: '宁夏',  
          label: '宁夏'  
        },  
        {  
          value: '山西',  
          label: '山西'  
        },  
        {  
          value: '湖南',  
          label: '湖南'  
        },  
        {  
          value: '江西',  
          label: '江西'  
        },  
        {  
          value: '安徽',  
          label: '安徽'  
        },  
        {  
          value: '云南',  
          label: '云南'  
        },  
        {  
          value: '贵州',  
          label: '贵州'  
        },  
        {  
          value: '海南',  
          label: '海南'  
        },  
        {  
          value: '西藏',  
          label: '西藏'  
        },  
        {  
          value: '内蒙',  
          label: '内蒙'  
        },
      ],
      selectedDistrictValue: 'all',
      indicatorsList: [
        {
          label: '',
          options: [
            {
              value: '',
              label: '无'
            }
          ],
        },
        {
          label: 'MA指标',
          options: [
            {
              value: 'MA_2_LONG',
              label: 'MA多头排列(2均线)'
            },
            {
              value: 'MA_2_SHORT',
              label: 'MA空头排列(2均线)'
            },
            {
              value: 'MA_LONG',
              label: 'MA多头排列(3均线)'
            },
            {
              value: 'MA_SHORT',
              label: 'MA空头排列(3均线)'
            },
            {
              value: 'MA_CROSSUP',
              label: 'MA金叉'
            },
            {
              value: 'MA_CROSSDOWN',
              label: 'MA死叉'
            },
            {
              value: 'Up_MA1',
              label: 'MA5上方收盘'
            },
            {
              value: 'Down_MA1',
              label: 'MA5下方收盘'
            },
            {
              value: 'Up_MA2',
              label: 'MA10上方收盘'
            },
            {
              value: 'Down_MA2',
              label: 'MA10下方收盘'
            },
            {
              value: 'Up_MA3',
              label: 'MA20上方收盘'
            },
            {
              value: 'Down_MA3',
              label: 'MA20下方收盘'
            },
          ],
        },
        {
          label: 'BOLL指标',
          options: [
            {
              value: 'UP_BOLL_MID',
              label: '布林中轨上方收盘'
            },
            {
              value: 'DOWN_BOLL_MID',
              label: '布林中轨下方收盘'
            },
            {
              value: 'BOLL_CROSSUP_MID',
              label: '突破布林中轨'
            },
            {
              value: 'BOLL_CROSSDOWN_MID',
              label: '跌破布林中轨'
            },
          ],
        },
        {
          label: 'MACD指标',
          options: [
            {
              value: 'MACD_CROSSUP',
              label: 'MACD金叉'
            },
            {
              value: 'MACD_CROSSDOWN',
              label: 'MACD死叉'
            },
            {
              value: 'MACD_RED',
              label: 'MACD红柱'
            },
            {
              value: 'MACD_GREEN',
              label: 'MACD绿柱'
            },
          ],
        },
        {
          label: 'KDJ指标',
          options: [
            {
              value: 'KDJ_CROSSUP',
              label: 'KDJ金叉'
            },
            {
              value: 'KDJ_CROSSDOWN',
              label: 'KDJ死叉'
            },
          ],
        },
      ],
      indicators: '',
      patternsList: [
        {
          label: '',
          options: [
            {
              value: '',
              label: '无'
            }
          ],
        },
        {
          label: '三k线组合',
          options: [
            {
              value: 'MorningStar',
              label: '早晨之星'
            },
            {
              value: 'EveningStar',
              label: '黄昏之星'
            },
          ],
        },
        {
          label: '两k线组合',
          options: [
            {
              value: 'EngulfingUp',
              label: '看涨吞没'
            },
            {
              value: 'EngulfingDown',
              label: '看跌吞没'
            },
            {
              value: 'Piercing',
              label: '向上刺透'
            },
            {
              value: 'DarkCloudCover',
              label: '乌云压顶'
            },
          ],
        },
        {
          label: '单k线模式',
          options: [
            {
              value: 'MarubozuUp',
              label: '实体饱满阳'
            },
            {
              value: 'MarubozuDown',
              label: '实体饱满阴'
            },
            {
              value: 'Hammer',
              label: '锤子形态'
            },
            {
              value: 'ShootingStar',
              label: '流星形态'
            },
            {
              value: 'Dragonfly',
              label: '蜻蜓十字'
            },
            {
              value: 'Gravestone',
              label: '墓碑十字'
            },
            {
              value: 'Dojistar',
              label: '十字星'
            },
          ],
        },
        {
          label: '其他',
          options: [
            {
              value: 'up',
              label: '收阳'
            },
            {
              value: 'down',
              label: '收阴'
            },
            {
              value: '2up',
              label: '二连阳'
            },
            {
              value: '2down',
              label: '二连阴'
            },
            {
              value: '3up',
              label: '三连阳'
            },
            {
              value: '3down',
              label: '三连阴'
            },
          ],
        },
      ],
      patterns: '',
      dataList: [],
      date: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.technicalData === '') {
        // 无缓存，从后台请求数据
        // requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let block = obj.selectedBlockValue
      let index = obj.selectedIndexValue
      block = block + "," + index
      if (obj.selectedIndustryValue != "all") {
        block = block + "," + obj.selectedIndustryValue
      }
      if (obj.selectedDistrictValue != "all") {
        block = block + "," + obj.selectedDistrictValue
      }
      let formData = new FormData()
      formData.append("block", block)
      formData.append("indicators", obj.indicators)
      formData.append("patterns", obj.patterns)
      formData.append("page", obj.page)
      formData.append("limit", obj.limit)
      http({
        url: `/technical`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.data.length === 0) {
          ElMessage.error('没有查询到数据')
          obj.dataList = []
          obj.total = 0
          obj.page = 1
          obj.date = ''
        }
        processData(res.data.data)
        setStore()
      }).catch(error => {
        // 处理错误 (DeadLogic)
        // console.error('发生错误:', error)
        obj.dataList = []
        obj.total = 0
        obj.page = 1
        obj.date = ''
      })
    }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chg = parseFloat(item.chg).toFixed(2)
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
          item.volForSort = parseFloat(item.vol)
          item.vol = bigNumberTransform(parseFloat(item.vol / 100)) // 成交量除以100换成手数
          item.turnoverForSort = parseFloat(item.turnover)
          item.turnover = bigNumberTransform(parseFloat(item.turnover))
          item.turnoverRate_ma1 = (item.turnoverRate_ma1 * 100).toFixed(2) + '%'
          item.amplitude = (item.amplitude * 100).toFixed(2) + '%'
        }
        item.no = no
        no++

        if (item.index == "") {
          item.index = "-"
        }
        if (item.industry == "") {
          item.industry = "-"
        }
        if (item.district == "") {
          item.district = "-"
        }
      })
      obj.total = data.total
      obj.dataList = data.data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'selectedBlockValue': obj.selectedBlockValue,
        'selectedIndexValue': obj.selectedIndexValue,
        'selectedIndustryValue': obj.selectedIndustryValue,
        'selectedDistrictValue': obj.selectedDistrictValue,
        'indicators': obj.indicators,
        'patterns': obj.patterns,
        'dataList': obj.dataList,
        'date': obj.date,
        'total': obj.total,
        'page': obj.page,
      }
      store.commit('setTechnicalData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.selectedBlockValue = store.state.technicalData.selectedBlockValue
      obj.selectedIndexValue = store.state.technicalData.selectedIndexValue
      obj.selectedIndustryValue = store.state.technicalData.selectedIndustryValue
      obj.selectedDistrictValue = store.state.technicalData.selectedDistrictValue
      obj.indicators = store.state.technicalData.indicators
      obj.patterns = store.state.technicalData.patterns
      obj.dataList = store.state.technicalData.dataList
      obj.date = store.state.technicalData.date
      obj.total = store.state.technicalData.total
      obj.page = store.state.technicalData.page
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      // requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      if (!formCheck()) {
        return
      }
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    // 分页变化事件
    const handlePageChange = (value) => {
      obj.page = value
      requestData()
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.open > row.row.preClose && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.open < row.row.preClose && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.low > row.row.preClose && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.low < row.row.preClose && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.high > row.row.preClose && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.high < row.row.preClose && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.close > row.row.preClose && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.close < row.row.preClose && row.columnIndex === 3) {
        return { color: 'green' }
      }
      if (row.row.trend_ma1 > 0 && row.columnIndex === 12) {
        return { color: 'red' }
      } else if (row.row.trend_ma1 < 0 && row.columnIndex === 12) {
        return { color: 'green' }
      }
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customVolSort = (a, b) => {
      return a.volForSort - b.volForSort
    }

    // 表格排序(带金额单位的数字列)
    const customTurnoverSort = (a, b) => {
      return a.turnoverForSort - b.turnoverForSort
    }

    // 表格排序(带百分号的数字列)
    const customTurnoverRateSort = (a, b) => {
      return parseFloat(a.turnoverRate_ma1.replace('%', '')) - parseFloat(b.turnoverRate_ma1.replace('%', ''))
    }

    // 表格排序(带百分号的数字列)
    const customAmplitudeSort = (a, b) => {
      return parseFloat(a.amplitude.replace('%', '')) - parseFloat(b.amplitude.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleRowClick,
      handleSubmit,
      cellStyle,
      customPctSort,
      customVolSort,
      customTurnoverSort,
      customTurnoverRateSort,
      customAmplitudeSort,
      handlePageChange
    }
  }
}
</script>
<style lang="scss" scoped></style>
